import ProjectAddDialog from './ProjectAddDialog';
import ConnectedProjectAddDialog from './ConnectedProjectAddDialog';

export { ProjectAddDialog };
export default ConnectedProjectAddDialog;
